var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_10760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C8.68802 6 6 8.68802 6 12C6 15.312 8.68802 18 12 18C15.312 18 18 15.312 18 12C18 8.68796 15.312 6 12 6Z",
    fill: "#4B57E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37001 0 0 5.37001 0 12C0 18.6299 5.37001 23.9999 12 23.9999C18.6299 23.9999 24 18.63 24 12C24 5.36996 18.63 0 12 0ZM12 21.6C6.69599 21.6 2.39996 17.304 2.39996 12C2.39996 6.69594 6.69599 2.40002 12 2.40002C17.3039 2.40002 21.6 6.69599 21.6 12C21.6 17.3039 17.304 21.6 12 21.6Z",
    fill: "#4B57E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_10760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCircle);
export default __webpack_public_path__ + "static/media/active-circle.6f00e28dc2df24b70037e232839e2470.svg";
export { ForwardRef as ReactComponent };